import { createContext, useContext } from "react";

import { ProductI18nOptionFormModelContext } from "../../context/context";

import type { ProductOptionI18nFormModelContextType } from "../../context/context";

export type ProductExistingOptionI18nFormModelContextType = {
	onUpdate: () => void;
} & ProductOptionI18nFormModelContextType;

export const ProductExistingOptionI18nFormModelContext =
	createContext<ProductExistingOptionI18nFormModelContextType | null>(null);

export const ProductExistingOptionI18nFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductExistingOptionI18nFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductExistingOptionI18nFormModelContext.Provider value={value}>
			<ProductI18nOptionFormModelContext.Provider value={value}>
				{children}
			</ProductI18nOptionFormModelContext.Provider>
		</ProductExistingOptionI18nFormModelContext.Provider>
	);
};

export const useProductExistingOptionI18nFormModelContext = () => {
	const context = useContext(ProductExistingOptionI18nFormModelContext);

	if (!context) {
		throw new Error(
			"useProductExistingOptionI18nFormModelContext must be used within a ProductExistingOptionI18nFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
